import { render, staticRenderFns } from "./ContractNavigationWrapper.vue?vue&type=template&id=2ba6fe2a&scoped=true&"
import script from "./ContractNavigationWrapper.vue?vue&type=script&lang=js&"
export * from "./ContractNavigationWrapper.vue?vue&type=script&lang=js&"
import style0 from "./ContractNavigationWrapper.vue?vue&type=style&index=0&id=2ba6fe2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba6fe2a",
  null
  
)

export default component.exports